export default __webpack_public_path__ + "static/media/bg-image-3.e12a7844.jpg";